import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import InputDatePicker from 'components/common/InputDatePicker';
import SpAccountManagerDropdown from 'components/dropdowns/SpSalePerson/SpAccountManagerDropdown';
import Flex from 'components/common/Flex';
import SpCustomerDropdown from 'components/dropdowns/SpSalePerson/SpCustomerDropdown';
import SpCustomerTypeDropdown from 'components/dropdowns/SpSalePerson/SpCustomerTypeDropdown';
const MyVisitHistoryFilter = ({
  formData,
  handleChange,
  handleSubmit,
  style,
  displayOption = {},
  isFromManagerPage
}) => {
  console.log(formData);
  return (
    <Card>
      <Card.Body className="bg-light">
        <Row style={style}>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <InputDatePicker
              column="visitDate"
              displayName="Visit Date"
              selected={formData?.visitDate}
              handleChange={handleChange}
            />
          </Col>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <Flex alignItems="center" justifyContent="between">
              <Form.Label>Visit Type</Form.Label>
            </Flex>
            <SpCustomerTypeDropdown
              keyId={'customerType'}
              handleChange={handleChange}
              selectedId={formData?.customerType ?? -1}
            />
          </Col>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <Flex alignItems="center" justifyContent="between">
              <Form.Label>Customers</Form.Label>
            </Flex>
            <SpCustomerDropdown
              keyId={'customerIdStr'}
              handleChange={(key, opt) => {
                handleChange(key, opt.id);
              }}
              selectedIdStr={formData?.customerIdStr}
            />
          </Col>
          {isFromManagerPage && (
            <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
              <Flex alignItems="center" justifyContent="between">
                <Form.Label>Account Manager</Form.Label>
              </Flex>
              <SpAccountManagerDropdown
                label="Account Manager"
                placeholder="Account Manager"
                fieldName="sale"
                handleChange={(key, value) => handleChange(key, value?.id)}
                selectedOptions={formData?.sale}
              />
            </Col>
          )}
        </Row>
      </Card.Body>
      {displayOption && displayOption.showFooter && (
        <Card.Footer>
          <hr />
          <div className="text-center mt-2">
            <Button color="primary" onClick={handleSubmit}>
              Search
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};
MyVisitHistoryFilter.propTypes = {
  formData: PropTypes.object,
  displayOption: PropTypes.object,
  handleSubmit: PropTypes.func,
  saveConfig: PropTypes.func,
  style: PropTypes.object,
  handleChange: PropTypes.func,
  searchKeyword: PropTypes.string,
  isParentFullRow: PropTypes.bool,
  isFromManagerPage: PropTypes.bool
};

export default MyVisitHistoryFilter;
